var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0077b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.32 4.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58073",
    "data-name": "Path 58073",
    d: "M37.553,35.077A2.077,2.077,0,1,1,35.477,33,2.077,2.077,0,0,1,37.553,35.077Z",
    transform: "translate(-33.4 -33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58074",
    "data-name": "Path 58074",
    d: "M39.977,69.795v9.174a.514.514,0,0,1-.514.516H37.275a.514.514,0,0,1-.515-.515V69.795a.515.515,0,0,1,.515-.515h2.189A.515.515,0,0,1,39.977,69.795Z",
    transform: "translate(-36.295 -64.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58075",
    "data-name": "Path 58075",
    d: "M80.461,73.623v4.441a.472.472,0,0,1-.473.473H77.634a.472.472,0,0,1-.473-.473v-4.3c0-.642.188-2.813-1.679-2.813-1.447,0-1.742,1.485-1.8,2.153v4.964a.473.473,0,0,1-.467.473H70.942a.472.472,0,0,1-.472-.473V68.807a.472.472,0,0,1,.472-.473h2.273a.473.473,0,0,1,.473.473v.8A3.222,3.222,0,0,1,76.72,68.18C80.483,68.18,80.461,71.694,80.461,73.623Z",
    transform: "translate(-65.338 -63.31)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7469ceff9c0d2b53f0cb95193fe9666e.svg";
export { ForwardRef as ReactComponent };